export default __webpack_public_path__ + "empty-watchlist-4ac7d3fceccf738aaedc5d3586b23794.png";